import { MARKETING_SERVICES } from '../constants/content';

export default function Marketing() {
  return (
    <section className="fm-section fm-section--soft" id="marketing">
      <div className="fm-container">
        <div className="fm-sec-head">
          <p className="fm-kicker">Digital marketing</p>
          <h2 className="fm-sec-title">Digital marketing that drives results</h2>
          <p className="fm-sec-lead">
            Plan campaigns, nurture leads, publish social content, and measure
            performance with tools built for modern growth teams.
          </p>
        </div>
        <div className="fm-market-grid">
          {MARKETING_SERVICES.map((item) => (
            <article key={item.title} className="fm-market-item">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
